var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('full-calendar',{ref:"calendar",staticClass:"mt-4",attrs:{"config":_vm.calendarConfig,"events":_vm.calendarEvents},on:{"view-render":_vm.onViewRender}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }